const InitialState = {
    title: '',
    customFactors: null,
};

export {
    InitialState,
}